<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Trang chủ" :link="[{ text: 'Dashboard', href: '../dashboard' }]" />
      </div>
    </div>

    <!-- Thông tin toàn trường -->
    <v-card outlined class="pa-2 mx-4 mb-6 elevation-0">
      <v-row>
        <v-col cols="6">
          <v-col cols="12">
            <h2>{{ $_get(currentSchoolYear, 'name', 'Năm học') }}</h2>
          </v-col>
          <v-col cols="12">
            {{ currentSemester.title }}
          </v-col>
        </v-col>
        <v-col cols="6" v-if="role.type !== 'chef'">
          <v-row class="ma-4 ml-0 justify-end">
            <v-col class="mr-4 pa-0">
              <v-card
                class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
                style="background-color: #BBDEFB"
              >
                <div style="font-size: 24px">{{ classNo }}</div>
                <div class="text-caption">Lớp</div>
              </v-card>
            </v-col>
            <v-col class="mr-4 pa-0">
              <v-card
                class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
                style="background-color: #BBDEFB"
              >
                <div style="font-size: 24px">{{ studentNo }}</div>
                <div class="text-caption">Học sinh</div>
              </v-card>
            </v-col>
            <v-col class="pa-0">
              <v-card
                class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
                style="background-color: #BBDEFB"
              >
                <div style="font-size: 24px">{{ teacherNo }}</div>
                <div class="text-caption">Giáo viên</div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>

    <!-- Điểm danh - Khen thưởng - Kỷ luật -->
    <v-row class="mx-1 mb-4" v-if="role.type !== 'inspector'">
      <v-col cols="6" v-if="$auth.policies['view-attendance-item']">
        <v-card outlined>
          <v-card-title class="pr-0">
            <v-icon color="primary">mdi-calendar-account</v-icon>
            <span class="ml-2 text-subtitle-2">SL HS điểm danh hôm nay</span>
            <v-spacer></v-spacer>
            <v-btn @click="goDetail" color="primary" text>Xem chi tiết</v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-row class="py-6">
              <v-col class="pl-6 text-center divider-col" cols="4">
                <span class="col-1">{{ todayAttendanceCount }}</span>
                <br />
                <span class="text-subtitle">Đang có mặt</span>
              </v-col>
              <!-- <v-col class="text-center" cols="1">
                <v-divider class="my-2" vertical></v-divider>
              </v-col> -->
              <v-col class="text-center divider-col" cols="4">
                <span class="col-3th">{{ todayAbsentCount }}</span> <br />
                <span class="text-subtitle">Vắng/quên quẹt thẻ</span>
              </v-col>
              <!-- <v-col class="text-center" cols="1">
                <v-divider class="my-2" vertical></v-divider>
              </v-col> -->
              <v-col class="pl-6 text-center divider-col" cols="4">
                <span class="col-1">{{ todayCheckoutCount}}</span>
                <br />
                <span class="text-subtitle">Đã ra về</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" v-if="$auth.policies['view-violation-list']">
        <v-card outlined>
          <v-card-title class="pr-0">
            <v-icon color="primary">mdi-star</v-icon>
            <span class="ml-2 text-subtitle-2">SL Khen thưởng kỷ luật trong tuần</span>
            <v-spacer></v-spacer>
            <v-btn color="primary" text to="/complimented">Xem chi tiết</v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-row class="py-6">
              <v-col class="text-center" cols="4">
                <span class="col-1">{{ commendationWeekCount || 0 }}</span>
                <br />
                <span class="text-subtitle">Khen thưởng</span>
              </v-col>
              <v-divider class="my-2" vertical></v-divider>
              <v-col class="text-center" cols="4">
                <span class="col-2">{{ violationWeekCount || 0 }}</span> <br />
                <span class="text-subtitle">Kỷ luật</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Phản hồi -->
    <v-card class="mx-4 mb-6" outlined v-if="$auth.policies['view-feedback-group'] && role.type !== 'inspector'">
      <v-card-title class="pr-0">
        <v-icon color="primary">mdi-forum</v-icon>
        <span class="ml-2 text-subtitle-2">Phản hồi phụ huynh gần đây</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" text to="/feedback">Xem thêm</v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <DashboardFeedbacks />
      </v-card-text>
    </v-card>

    <!-- Thông báo -->
    <v-card outlined class="mx-4" v-if="$auth.policies['view-noti-history']">
      <v-card-title class="pr-0">
        <v-icon color="primary">mdi-bell-ring</v-icon>
        <span class="ml-2 text-subtitle-2">Thông báo nhà trường gần đây</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" text to="/post-history">Xem thêm</v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <DashboardNotifications />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapActions, mapGetters, mapState } from 'vuex'
import DashboardNotifications from '@/modules/dashboard/DashboardNotifications.vue'
import DashboardFeedbacks from '@/modules/dashboard/DashboardFeedbacks.vue'

export default {
  components: {
    Breadcrumbs,
    DashboardNotifications,
    DashboardFeedbacks
  },
  computed: {
    ...mapState('app', ['currentSchoolYear', 'currentSemester']),
    ...mapState('Dashboard', [
      'classNo',
      'studentNo',
      'teacherNo',
      'todayAttendanceCount',
      'todayAbsentCount',
      'todayCheckoutCount',
      'commendationWeekCount',
      'violationWeekCount'
    ]),
    ...mapGetters('auth', ['profile', 'role'])
  },
  async created() {
    if (this.role.type !== 'chef') await this.fetchDashboardData()
  },
  methods: {
    ...mapActions('Dashboard', ['fetchDashboardData']),

    goDetail() {
      this.$router.push(`/attendances?searchImmediate=true`)
    }
  }
}
</script>

<style scoped>
.col-1 {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #46be8a;
}
.col-2 {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #ffab40;
}
.col-3th {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #fd6b6b;
}
.divider-col {
  position: relative;
}

.divider-col:after {
  content: "";
  display: block;
  height: 80%;
  width: 1px;
  position: absolute;
  top: 10%;
  right: -0.5px;
  background: #E0E0E0;
}

.divider-col:last-child::after {
  display: none;
}
/* .divider-col:first-child::after {
  display: none;
} */

</style>
